import { CKNavTooltip } from 'clearkit';
import { NavLink, Route } from 'react-router-dom';

function SidebarNavLink(props) {
  const {
    onClick,
    exact,
    classes,
    icon: Icon,
    iconSize = 16,
    hover = true,
    title,
    to,
    href,
    target,
    rel,
  } = props;

  return (
    <Route exact={exact} path={to}>
      {({ match }) => {
        const isActive = to && match;

        const labelClasses = classnames('sr-only');
        const linkClasses = classnames(
          'border w-9 h-9 flex items-center justify-center relative group rounded',
          {
            'border-blue-200 bg-blue-50': isActive,
            'border-transparent': !isActive,
            'hover:border-gray-200 hover:bg-gray-0 text-gray-600 hover:text-gray-900':
              !isActive && hover,
          },
          classes.focusColor,
        );

        const icon = (
          <Icon
            className={classnames({ 'fill-gradient-br-blue': isActive })}
            height={iconSize}
            width={iconSize}
          />
        );

        return (
          <CKNavTooltip
            className="z-20"
            tooltip={title}
            variant="x"
            options={{ placement: 'right' }}>
            <li className="relative">
              {to && (
                <NavLink to={to} className={linkClasses} onClick={onClick}>
                  {icon}
                  <span className={labelClasses}>{title}</span>
                </NavLink>
              )}
              {href && (
                <a
                  href={href}
                  className={linkClasses}
                  onClick={onClick}
                  target={target}
                  rel={rel}>
                  {icon}
                  <span className={labelClasses}>{title}</span>
                </a>
              )}
              <div className={classes.tooltip}>{title}</div>
            </li>
          </CKNavTooltip>
        );
      }}
    </Route>
  );
}

SidebarNavLink.defaultProps = {
  exact: false,
};

SidebarNavLink.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  exact: PropTypes.bool,
  hover: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.elementType.isRequired,
  iconSize: PropTypes.number,
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
};

export default SidebarNavLink;
